import { Alert, Typography, VStack } from '@vivaahealth/design-system';

interface AlertMessageProps {
  header: string;
  subheader: string;
  variant: 'danger' | 'info';
}

const AlertMessage = (props: AlertMessageProps) => {
  const { header, subheader, variant } = props;
  return (
    <Alert variant={variant}>
      <VStack gap={8}>
        <Typography variant="title-medium" bold>
          {header}
        </Typography>
        <Typography variant="paragraph-medium">{subheader}</Typography>
      </VStack>
    </Alert>
  );
};

export default AlertMessage;
